import React, { useEffect, useState } from 'react';
import { UIContextEvent, WarsEvents } from '@playroomkit/pr-wars/events';
import { useManager } from '@src/contexts/WarsContext';
import './EndGame.css';
import { UIContextType } from '@playroomkit/pr-wars-data';
import View from '@components/View';
import ScalableWrapper from '@components/ScalableWrapper';

const EndGame: React.FC = () => {
  const [showUI, setShowUI] = useState(false);
  const manager = useManager();

  useEffect(() => {
    const handleUIContextEvent = (event: Event) => {
      let e = event as UIContextEvent,
        display = e.hasContext(UIContextType.GAMEOVER) && manager.isHost();
      
      setShowUI(display);
    }

    document.addEventListener(WarsEvents.UIContextEvent, handleUIContextEvent);

    return () => {
      document.removeEventListener(WarsEvents.UIContextEvent, handleUIContextEvent);
    };

  }, [showUI]);

  const handleEndGame = () => {
    manager.quitToLobby();
    setShowUI(false);
  }

  if(!showUI) return null
  
  return (
  <View className="end-button-wrapper">
    <ScalableWrapper maintainAspectRatioBy="height" anchor="bottom-right" >
      <View className='end-button-container'>
        <View enableEventCapturing>
          <button className="end-button" onClick={handleEndGame}>
            <img src="img/UI/Lobby_Button.png" alt="back to lobby" className='icon' />
          </button>
        </View>
      </View>
    </ScalableWrapper>
  </View>
)}

export default EndGame;
